module.exports = __webpack_public_path__ + "7797b415b2ef9d2eccbd67c6a8b133c7.svg";